import React from 'react';

class MakeMediaRead extends React.Component {
  componentDidMount() {
    window.addEventListener('wheel', this.handleWheel);
  };

  componentWillUnmount() {
    window.removeEventListener('wheel', this.handleWheel);
  };

  handleWheel = (event) => {
    let scrollTop = document.documentElement.scrollTop;
    let windowHeight = document.documentElement.clientHeight;
    let elements = document.querySelectorAll('.media-unread');
    let result = [];
    elements.forEach((element) => {
      if(scrollTop <= element.offsetTop && (element.offsetHeight + element.offsetTop) < (scrollTop + windowHeight)){
        result.push(element);
      }
    });
    this.props.onRead(result.map(e => parseInt(e.getAttribute('data-id'))));
  };

  render() {
    return <>{this.props.children}</>
  }
}

export default MakeMediaRead;